import { Inbox } from 'lucide-react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import useShowAI from '../../../hooks/use-show-ai';
import { AiPageReviewModal } from '../ai-page-review-modal';

export const NoTaskAdded = () => {
  const { t } = useTranslation();
  const showAI = useShowAI();
  return (
    <div className="text-textcolor flex flex-col items-center justify-center gap-2 mt-6 min-h-56
    ">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className='flex flex-col'>
        <div className='flex flex-col justify-center items-center'>
          <Inbox size={18} />
          <span className="text-base font-semibold">
            {t('no_tasks.title', 'You’re all up to date')}
          </span>
        </div>
        <span className="text-center text-sm px-4 mb-2">
          {t('no_tasks.description', 'It looks like there are no active tasks in this project, why not try AtarimAI to review the current view for you')}
        </span>
        {showAI &&
          <AiPageReviewModal buttonText={t('no_tasks.button', 'Run AI Review')} />
        }
      </motion.div>
    </div>
  );
};